module.exports = __webpack_public_path__ + "media/images/home-banner-6988b11d46dd07efab769a2f44074928.jpg";